import { useEffect, type FC } from 'react';
import { Outlet, ScrollRestoration } from 'react-router-dom';
import Toast from '@ui/toast';
import Header from '@components/header';
import styles from './index.module.scss';
import { toast } from 'react-toastify';
import { useSuiClient } from '@mysten/dapp-kit';
import { useParrotInitCoins } from '@hooks/use-parrot-coins';
import ParrotLoading from './parrot-loading';

const App: FC = () => {
  const client = useSuiClient();
  const coins = useParrotInitCoins();

  const getCoin = async () => {
    try {
      await client.getCoinMetadata({ coinType: '0x2::sui::SUI' });
    } catch (err) {
      toast(
        <div style={{ color: 'red' }}>
          The current node is temporarily unavailable. Please switch to an alternative node to
          ensure uninterrupted service.
        </div>,
        { type: 'error' },
      );
    }
  };

  useEffect(() => {
    getCoin();
  }, [client]);

  return (
    <>
      <ScrollRestoration />
      {!coins ? (
        <ParrotLoading />
      ) : (
        <>
          <Header />
          <div className={styles.body}>
            <Outlet />
          </div>
        </>
      )}
      <Toast />
    </>
  );
};

export default App;
